import React, { useEffect, useState } from "react";
import Activityehead from "./Activityhead";
import axios from "axios";
import { API_BASE_URL } from "../config";
// import pdfss from "../pdf.json";

const Newsletter = () => {
  const [slidesData, setSlidesData] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [toggleSwitch, setToggleSwitch] = React.useState({});
  const getPdfData = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/mypdfData`);
      const fetchedData = response.data.data;
      const initialSwitchState = {};
      fetchedData.forEach((slide) => {
        initialSwitchState[slide.id] = slide.Published;
      });
      setSlidesData(response.data.data);
      if (response?.data?.data) {
        setLoading(true);
      }
      console.log("f", fetchedData);

      // setToggleSwitch(initialSwitchState);
    } catch (e) {
      console.log("err", e);
    }
  };
  useEffect(() => {
    getPdfData();
  }, []);
  // const downloadPdf = (base64String, filename) => {
  //   // Convert base64 to a Blob
  //   const byteCharacters = atob(base64String.split(",")[1]); // Remove base64 header
  //   const byteNumbers = new Array(byteCharacters.length);
  //   for (let i = 0; i < byteCharacters.length; i++) {
  //     byteNumbers[i] = byteCharacters.charCodeAt(i);
  //   }
  //   const byteArray = new Uint8Array(byteNumbers);
  //   const file = new Blob([byteArray], { type: "application/pdf" });

  //   // Create a URL for the Blob
  //   const fileURL = URL.createObjectURL(file);

  //   // Create a temporary anchor and trigger the download
  //   const tempLink = document.createElement("a");
  //   tempLink.href = fileURL;
  //   tempLink.download = filename;
  //   document.body.appendChild(tempLink);
  //   tempLink.click();
  //   document.body.removeChild(tempLink);
  // };
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const section = document.getElementById(hash.substring(1));
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, []);
  return (
    <>
      <div>
        <Activityehead />
      </div>
      <div className="mx-4">
        <h1
          className="my-8 text-center font-['Roboto'] text-4xl font-bold "
          style={{ lineHeight: "51px" }}
        >
          Our Newsletters
        </h1>
      </div>
      <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mx-4">
        {!loading && (
          <div className="fixed inset-0 top-1/2 left-1/2">
            <div role="status">
              <svg
                aria-hidden="true"
                class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        )}

        {slidesData &&
          [...slidesData].reverse().map((slide, index) => {
            return (
              <>
                {slide?.Published && (
                  <div
                    key={index}
                    className="md:space-y-10 flex flex-col  bg-[#1A2338] border border-[#000] justify-items-center"
                  >
                    <img
                      src={slide.Photo}
                      alt="photos"
                      className="flex self-center"
                    />
                    <div className=" text-white lg:py-[20px] px-[10px] py-[15px] lg:px-[17px]  space-y-6">
                      <h1 className="text-xl">{slide?.Heading}</h1>

                      <hr className="h-0.5 w-full bg-white" />
                      <div className="flex items-center justify-between">
                        <p>
                          {slide.Month} {slide.Year}
                        </p>

                        <a
                          href={slide.Pdf}
                          download
                          className="download-button bg-white text-[#1A2338] px-3 rounded-lg py-2"
                        >
                          Download PDF
                        </a>
                      </div>
                    </div>
                  </div>
                )}
              </>
            );
          })}
      </div>
    </>
  );
};

export default Newsletter;
